export default __webpack_public_path__ + "static/media/photo3.9a435f76.jpg";